/**
 * Twilio SMS — platform status check.
 *
 * Mirrors ``backend/app/routers/integrations.py:/integrations/sms/status``.
 * No auth-token info is returned to the SPA — only whether the
 * platform admin has configured Twilio credentials.
 */
import client from "./client";

export interface SmsStatusResponse {
  configured: boolean;
  phone_number: string | null;
}

export async function getSmsStatus(): Promise<SmsStatusResponse> {
  const res = await client.get<SmsStatusResponse>("/integrations/sms/status");
  return res.data;
}
